import React from 'react';
import { Field, TextInput, SelectInput, ButtonGroup } from '../lib/FormControls';
import { GENDER_OPTIONS, ID_TYPE_OPTIONS } from '../lib/fieldDefs';

export default function Step2PersonalInfo({ form, setField }) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-gray-900">Personal Information</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Full Name" required>
          <TextInput value={form.full_name} onChange={(e) => setField('full_name', e.target.value)} />
        </Field>
        <Field label="Birth State/Country" required>
          <TextInput
            value={form.birth_state_country}
            onChange={(e) => setField('birth_state_country', e.target.value)}
          />
        </Field>
        <Field label="Birth Date" required>
          <TextInput
            type="date"
            value={form.birth_date}
            onChange={(e) => setField('birth_date', e.target.value)}
          />
        </Field>
        <Field label="Gender" required>
          <ButtonGroup
            options={GENDER_OPTIONS}
            value={form.gender}
            onChange={(v) => setField('gender', v)}
          />
        </Field>
        <Field label="SSN/ITIN" sensitive required>
          <TextInput value={form.ssn} onChange={(e) => setField('ssn', e.target.value)} />
        </Field>
        <Field label="Address" required>
          <TextInput value={form.address} onChange={(e) => setField('address', e.target.value)} />
        </Field>
        <Field label="Years At Address">
          <TextInput
            value={form.years_at_address}
            onChange={(e) => setField('years_at_address', e.target.value)}
          />
        </Field>
        <Field label="Cell Phone" required>
          <TextInput value={form.cell_phone} onChange={(e) => setField('cell_phone', e.target.value)} />
        </Field>
        <Field label="Email" required>
          <TextInput
            type="email"
            value={form.email}
            onChange={(e) => setField('email', e.target.value)}
          />
        </Field>
        <Field label="Citizenship" required>
          <TextInput
            value={form.citizenship}
            onChange={(e) => setField('citizenship', e.target.value)}
          />
        </Field>
        <Field label="ID Type" required>
          <SelectInput
            value={form.id_type}
            onChange={(e) => setField('id_type', e.target.value)}
            options={ID_TYPE_OPTIONS}
          />
        </Field>
        <Field label="ID Number" required>
          <TextInput value={form.id_number} onChange={(e) => setField('id_number', e.target.value)} />
        </Field>
        <Field label="ID State">
          <TextInput value={form.id_state} onChange={(e) => setField('id_state', e.target.value)} />
        </Field>
        <Field label="ID Expiration" required>
          <TextInput
            type="date"
            value={form.id_expiration}
            onChange={(e) => setField('id_expiration', e.target.value)}
          />
        </Field>
      </div>

      <div className="rounded-lg border border-gray-200 p-4">
        <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-secondary">
          Employment
        </h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Field label="Employer Name" required>
            <TextInput
              value={form.employer_name}
              onChange={(e) => setField('employer_name', e.target.value)}
            />
          </Field>
          <Field label="Employer Address">
            <TextInput
              value={form.employer_address}
              onChange={(e) => setField('employer_address', e.target.value)}
            />
          </Field>
          <Field label="Occupation" required>
            <TextInput
              value={form.occupation}
              onChange={(e) => setField('occupation', e.target.value)}
            />
          </Field>
          <Field label="Duties">
            <TextInput value={form.duties} onChange={(e) => setField('duties', e.target.value)} />
          </Field>
          <Field label="Employer Phone">
            <TextInput
              value={form.employer_phone}
              onChange={(e) => setField('employer_phone', e.target.value)}
            />
          </Field>
          <Field label="Years At Employer" required>
            <TextInput
              value={form.years_at_employer}
              onChange={(e) => setField('years_at_employer', e.target.value)}
            />
          </Field>
        </div>
      </div>
    </div>
  );
}
